export default "__VITE_ASSET__B7C1TWn3__"